import {atom, selector} from "recoil";

const spaceState = atom({
  key: 'spaceState',
  default: {
    id: null,
    isClosed: null,
    isOpened: null,
    isOpen: null,
    isEnded: null,
    isStarted: null,
    isLive: null,
  }
});

export const spaceIdState = selector({
  key: 'spaceTimingIdState',
  get: ({get}) => {
    return get(spaceState).id
  }
})

export default spaceState;
